import { TDimensions } from '@/components/Common/Layout/Layout';

const getDimensions = (id: string): TDimensions => {
  const elem = document.getElementById(id);
  let width = 0;
  let height = 0;
  if (elem) {
    ({ width, height } = elem?.getBoundingClientRect() ?? {});
  }
  return {
    width,
    height,
    elem,
  };
};

export default getDimensions;
